// extracted by mini-css-extract-plugin
export var closeButton = "_ku-1";
export var closeX = "_ku-3";
export var container = "_ku-0";
export var image = "_ku-2";